"use client";

import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import Head from 'next/head';
import Script from 'next/script';
import { IBM_Plex_Sans, IBM_Plex_Serif } from 'next/font/google';
import './styles/globals.css';
import Navbar from '../src/components/home/Navbar';
import ClientFooter from '../src/components/home/ClientFooter';
import { client } from '@/lib/sanity';

const ibmPlexSans = IBM_Plex_Sans({
  weight: ['400','500','600','700'],
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-ibm-plex-sans',
});

const ibmPlexSerif = IBM_Plex_Serif({
  weight: ['400','500','600','700'],
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-ibm-plex-serif',
});

export default function MyApp({ Component, pageProps }) {
  const [programs, setPrograms] = useState([]);
  const [workshops, setWorkshops] = useState([]);
  const [navDataLoaded, setNavDataLoaded] = useState(false);
  const router = useRouter();

  // Check if current route should hide navbar and footer
  const shouldHideLayout = router.pathname === '/newsletter/unsubscribe';

  useEffect(() => {
    const fetchNavData = async () => {
      try {
        const [programsData, workshopsData] = await Promise.all([
          client.fetch(`*[_type == "programs"] | order(id asc)`),
          client.fetch(`*[_type == "workshop"] | order(id asc)`),
        ]);

        setPrograms(programsData || []);
        setWorkshops(workshopsData || []);
      } catch (error) {
        console.error("Error fetching navbar data:", error);
        // Keep empty arrays as fallback
        setPrograms([]);
        setWorkshops([]);
      } finally {
        setNavDataLoaded(true);
      }
    };

    fetchNavData();
  }, []);

  return (
    <>
      <Head>
        <link rel="icon" href="/images/favicon-new.svg" />
        <title>GrowthSchool – Become the Top 1%</title>
        <meta
          name="description"
          content="Master the skills you need to become the top 1% in your field at GrowthSchool."
        />
      </Head>

      {!shouldHideLayout && (
        <Script
          src="https://in.fw-cdn.com/32121956/1131776.js"
          strategy="afterInteractive"
        />
      )}

      <div
        className={`antialiased ${ibmPlexSans.variable} ${ibmPlexSerif.variable}`}
      >
        {!shouldHideLayout && <Navbar programs={programs} workshops={workshops} />}
        <Component {...pageProps} />
        {!shouldHideLayout && <ClientFooter />}
      </div>
    </>
  );
}